import types from "./types";
import service from "./service";
// import swal from 'sweetalert';

const getCostpackages = () => {
    return (dispatch, getState) => {
        dispatch({ type: types.GET_COSTPACKAGE });
        service
            .getCostpackages(getState().costpackage.pagination.actualPage, getState().costpackage.filters)
            .then(result => {
                dispatch(getAllSuccess(result.list));
                dispatch(updatePagination(result.pagination));
            })
            .catch(err => dispatch(getAllFail(err)));
    };
};

const getCostpackageDetail = voa_id => {
    return (dispatch, getState) => {
        dispatch({ type: types.GET_COSTPACKAGE_DETAIL });
        service
            .getCostpackageDetail(voa_id)
            .then(result => dispatch(getDetailSuccess(result)))
            .catch(err => dispatch(getDetailFail(err)));
    };
};

const changePage = page => {
    return dispatch => {
        dispatch(changeCostPackagePage({ page: page }));
        dispatch(getCostpackages());
    };
};
const updateFilter = filters => {
    return dispatch => {
        dispatch(changeFilters(filters));
        dispatch(changeCostPackagePage({ page: 1 }));
        dispatch(getCostpackages());
    };
};

const getDetailSuccess = payload => ({
    type: types.GET_COSTPACKAGE_DETAIL_SUCCESS,
    payload
});

const getDetailFail = payload => ({
    type: types.GET_COSTPACKAGE_DETAIL_FAIL,
    payload
});

const changeFilters = payload => ({
    type: types.FILTER_LIST,
    payload
});

const changeCostPackagePage = payload => ({
    type: types.CHANGE_PAGE,
    payload
});

const getAllSuccess = payload => ({
    type: types.GET_COSTPACKAGE_SUCCESS,
    payload
});
const getAllFail = error => ({
    type: types.GET_COSTPACKAGE_FAIL,
    payload: error
});

const updatePagination = payload => ({
    type: types.UPDATE_PAGINATION,
    payload
});

export default {
    getCostpackages,
    getCostpackageDetail,
    changePage,
    updateFilter
};
